export enum AutomationRunStatus {
  Running = "running",
  Waiting = "waiting",
  Completed = "completed",
  Failed = "failed",
  Rejected = "rejected",
  Cancelled = "cancelled",
}
